import { render } from "./Popup.vue?vue&type=template&id=3b16e17f&ts=true"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"

import "./Popup.vue?vue&type=style&index=0&id=3b16e17f&lang=css"

import exportComponent from "/builds/conurse/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__